const storage = window.localStorage;

export class StorageService {
  constructor() {
    this.inMemoryStorage = {};
    this.length = 0;
    this.isSupported = this.isSupported.bind(this);
    this.setItem = this.setItem.bind(this);
    this.getItem = this.getItem.bind(this);
    this.clear = this.clear.bind(this);
    this.removeItem = this.removeItem.bind(this);
  }

  isSupported = () => {
    try {
      const testKey = '__test_key_to_determine_support__';
      storage.setItem(testKey, testKey);
      storage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  };

  setItem = (itemName, item) => {
    if (this.isSupported()) {
      storage.setItem(itemName, item);
    } else {
      this.inMemoryStorage[itemName] = String(item);
    }
  };

  getItem = itemName => {
    if (this.isSupported()) {
      return storage.getItem(itemName);
    }
    if (this.inMemoryStorage.hasOwnProperty(itemName)) {
      return this.inMemoryStorage[itemName];
    }
    return null;
  };

  clear = () => {
    if (this.isSupported()) {
      storage.clear();
    } else {
      this.inMemoryStorage = {};
    }
  };

  removeItem = itemName => {
    if (this.isSupported()) {
      storage.removeItem(itemName);
    } else {
      delete this.inMemoryStorage[itemName];
    }
  };
}
